export default __webpack_public_path__ + "img/sagoo/seq/sagoo3_700.jpg";